import React, { useState, useEffect } from "react";
import axios from "axios";
import { useUserContext } from "../../../contexts/UserContext";

export default function ChargeCreateModal({ open, onClose, onCreated }) {
  const { getAuthHeaders } = useUserContext();
  const [projects, setProjects] = useState([]);
  const [loadingProjects, setLoadingProjects] = useState(true);

  // 🔹 États pour la récurrence
  const [isRecurring, setIsRecurring] = useState(false);
  const [recurrenceStart, setRecurrenceStart] = useState("");
  const [duration, setDuration] = useState(12); // valeur par défaut : 12 mois

  // 🔹 Formulaire
  const [form, setForm] = useState({
    description: "",
    categorie: "Autres",
    customCategorie: "",
    modePaiement: "Espèces",
    dateDepense: "",
    statut: "Payée",
    montantTTC: "",
    preuvePDF: null,
    projectId: "",
  });

  // 🔹 Charger les projets si modal ouvert
  useEffect(() => {
    if (!open) return;

    const fetchProjects = async () => {
      try {
        const res = await axios.get("http://localhost:4000/data/any", {
          headers: getAuthHeaders(),
        });
        setProjects(res.data.projects || []);
      } catch (err) {
        console.error("Erreur chargement projets", err);
      } finally {
        setLoadingProjects(false);
      }
    };

    fetchProjects();
  }, [open]);

  if (!open) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const data = new FormData();

      // 🔹 Catégorie finale
      const finalCategorie =
        form.categorie === "__custom__"
          ? form.customCategorie
          : form.categorie;

      data.append("categorie", finalCategorie);
      data.append("description", form.description);
      data.append("modePaiement", form.modePaiement);
      data.append("dateDepense", form.dateDepense);
      data.append("statut", form.statut);
      data.append("montantTTC", form.montantTTC);

      if (form.projectId) data.append("projectId", form.projectId);
      if (form.preuvePDF) data.append("preuvePDF", form.preuvePDF);

      // 🔹 Gestion récurrence
      data.append("isRecurring", isRecurring);
      if (isRecurring) {
        data.append("recurrenceStart", recurrenceStart);

        const end = new Date(recurrenceStart);
        end.setMonth(end.getMonth() + Number(duration));
        data.append("recurrenceEnd", end.toISOString());

        data.append("recurrenceFrequency", "monthly");
        data.append("recurrenceNextDate", recurrenceStart);
      }

      // 🔹 Envoi au backend
      const res = await axios.post(
        "http://localhost:4000/new/charges",
        data,
        {
          headers: { ...getAuthHeaders(), "Content-Type": "multipart/form-data" },
        }
      );

      onCreated();
      onClose();
    } catch (err) {
      console.error("Erreur création charge", err);
    }
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-card glass">
        <h3>Nouvelle charge</h3>

           <div className="modal-body">
        <form onSubmit={handleSubmit} className="modal-form">
          {/* Date de dépense */}
          <input
            type="date"
            value={form.dateDepense}
            onChange={(e) => setForm({ ...form, dateDepense: e.target.value })}
            required
          />

          {/* Projet */}
          <label>Projet</label>
          <select
            value={form.projectId}
            onChange={(e) => setForm({ ...form, projectId: e.target.value })}
          >
            <option value="">— Aucun projet —</option>
            {projects.map((p) => (
              <option key={p._id} value={p._id}>
                {p.name} ({p.type})
              </option>
            ))}
          </select>

          {/* Catégorie */}
          <label>Catégorie</label>
          <select
            value={form.categorie}
            onChange={(e) => setForm({ ...form, categorie: e.target.value })}
          >
            {[
              "Loyer","Eau","Electricité","Internet","Transport",
              "Carburant","Salaires","Fournitures","Maintenance",
              "Impôts","Autres","__custom__",
            ].map((cat) => (
              <option key={cat} value={cat}>
                {cat === "__custom__" ? "➕ Autre catégorie" : cat}
              </option>
            ))}
          </select>

          {form.categorie === "__custom__" && (
            <input
              placeholder="Nouvelle catégorie"
              value={form.customCategorie}
              onChange={(e) =>
                setForm({ ...form, customCategorie: e.target.value })
              }
              required
            />
          )}

          {/* Récurrence */}
          <label>
            <input
              type="checkbox"
              checked={isRecurring}
              onChange={(e) => setIsRecurring(e.target.checked)}
            />{" "}
            Charge récurrente
          </label>

          {isRecurring && (
            <>
              <label>Début :</label>
              <input
                type="date"
                value={recurrenceStart}
                onChange={(e) => setRecurrenceStart(e.target.value)}
              />
              <label>Durée (mois) :</label>
              <input
                type="number"
                value={duration}
                onChange={(e) => setDuration(e.target.value)}
              />
            </>
          )}

          {/* Description */}
          <input
            placeholder="Description"
            value={form.description}
            onChange={(e) => setForm({ ...form, description: e.target.value })}
            required
          />

          {/* Montant TTC */}
          <input
            placeholder="Montant TTC"
            value={form.montantTTC}
            onChange={(e) => setForm({ ...form, montantTTC: e.target.value })}
            required
          />

          {/* Mode de paiement */}
          <select
            value={form.modePaiement}
            onChange={(e) => setForm({ ...form, modePaiement: e.target.value })}
          >
            {["Espèces","Mobile Money","Virement","Chèque","Carte"].map((m) => (
              <option key={m} value={m}>{m}</option>
            ))}
          </select>

          {/* Statut */}
          <select
            value={form.statut}
            onChange={(e) => setForm({ ...form, statut: e.target.value })}
          >
            {["En attente","Payée","Annulée"].map((s) => (
              <option key={s} value={s}>{s}</option>
            ))}
          </select>

          {/* Upload PDF */}
          <input
            type="file"
            name="preuvePDF"
            accept="application/pdf"
            onChange={(e) => setForm({ ...form, preuvePDF: e.target.files[0] })}
          />

          {/* Actions */}
          <div className="modal-actions">
            <button type="submit" className="btn-primary">Créer</button>
            <button type="button" className="btn-secondary" onClick={onClose}>
              Annuler
            </button>
          </div>
        </form>
        </div>
      </div>
    </div>
  );
}